import { makeTokenStore } from './tokenStorage';

// サイト入場証：長期(90日)なのでlocalStorageに保存する。
const store = makeTokenStore(localStorage, 'gj_site_token');

export const saveSiteToken = store.save;
export const clearSiteToken = store.clear;
export const getStoredSiteToken = store.get;
